
import React, {
    useState,
    useEffect,
    useRef,
    useContext
}
from "react";

import AmChartRingIndicator
from "../../../components/AmChartRingIndicator";

import {
    functions
}
from "../../../constants/common-functions";

import {
    store
}
from "../../../context/store.js";


//========================================================
// Home Box Utilisation
//
// Content-only component.
//
// The HomeBox wrapper and title are now managed
// by HomeDataScroller.
//========================================================

export default function HomeBoxUtilisation({
    homeConfig,
    isMobile = false
})
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // References
    //--------------------------------------------------------

    const thisId =
        useRef(null);


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [percentage1, setPercentage1] =
        useState(0);

    const [percentage2, setPercentage2] =
        useState(0);

    const [percentage3, setPercentage3] =
        useState(0);

    const [percentage4, setPercentage4] =
        useState(0);


    //--------------------------------------------------------
    // Temporary Totals
    //--------------------------------------------------------

    const [deskCount, setDeskCount] =
        useState(248);

    const [meetingRoomCount, setMeetingRoomCount] =
        useState(36);


    //--------------------------------------------------------
    // Filter
    //--------------------------------------------------------

    const filterBean =
        {};


    //========================================================
    // Load Utilisation Data
    //========================================================

    useEffect(
        function()
        {

            if(!queryContext)
            {
                return;
            }


            //------------------------------------------------
            // Peak Meeting Room Utilisation
            //------------------------------------------------

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/homeutilisationpeakmeetingroom",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                populateChartData1

            );


            //------------------------------------------------
            // Peak Desk Utilisation
            //------------------------------------------------

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/homeutilisationpeakdesk",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                populateChartData2

            );


            //------------------------------------------------
            // Average Meeting Room Utilisation
            //------------------------------------------------

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/homeutilisationaveragemeetingroom",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                populateChartData3

            );


            //------------------------------------------------
            // Average Desk Utilisation
            //------------------------------------------------

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/homeutilisationaveragedesk",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                populateChartData4

            );

        },
        [queryContext?.utilisationSurveyId]
    );


    //========================================================
    // Populate Charts
    //========================================================

    const populateChartData1 =
        function(data)
        {

            setPercentage1(

                functions.formatNumber(
                    data.returnDouble,
                    0
                )

            );

        };


    const populateChartData2 =
        function(data)
        {

            setPercentage2(

                functions.formatNumber(
                    data.returnDouble,
                    0
                )

            );

        };


    const populateChartData3 =
        function(data)
        {

            setPercentage3(

                functions.formatNumber(
                    data.returnDouble,
                    0
                )

            );

        };


    const populateChartData4 =
        function(data)
        {

            setPercentage4(

                functions.formatNumber(
                    data.returnDouble,
                    0
                )

            );

        };


    //========================================================
    // Main Container
    //========================================================

    const thisContainer =
    {
        display:
            "flex",

        width:
            "100%",

        flexDirection:
            "column",

        minHeight:
            isMobile
                ?
                "auto"
                :
                "350px",

        boxSizing:
            "border-box"
    };


    //========================================================
    // Rows
    //========================================================

    const rowsContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        flex:
            1,

        gap:
            "10px"
    };


    //--------------------------------------------------------
    // Utilisation Row
    //--------------------------------------------------------

    const utilisationRow =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        flex:
            1,

        minHeight:
            0,

        background:
            "rgba(25,29,33,0.035)",

        boxSizing:
            "border-box"
    };


    //========================================================
    // Row Header
    //========================================================

    const rowHeader =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "42px",

        flexShrink:
            0,

        alignItems:
            "center",

        padding:
            "6px",

        boxSizing:
            "border-box",

        background:
            "rgba(25,29,33,0.045)",

        border:
            "1px solid rgba(25,29,33,0.09)"
    };


    //--------------------------------------------------------
    // Header Title
    //--------------------------------------------------------

    const rowHeaderTitle =
    {
        display:
            "flex",

        alignItems:
            "center",

        flex:
            1,

        height:
            "28px",

        paddingLeft:
            "12px",

        color:
            "#344454",

        fontSize:
            "13px",

        fontWeight:
            600,

        letterSpacing:
            "0.15px",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // Header Metric Holder
    //--------------------------------------------------------

    const rowHeaderMetricHolder =
    {
        display:
            "flex",

        alignItems:
            "center",

        height:
            "28px",

        flexShrink:
            0
    };


    //--------------------------------------------------------
    // Header Metric Label
    //--------------------------------------------------------

    const rowHeaderMetricLabel =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        height:
            "28px",

        padding:
            "0px 10px",

        color:
            "#62686d",

        fontSize:
            "11px",

        fontWeight:
            500
    };


    //--------------------------------------------------------
    // Blue Information Pill
    //--------------------------------------------------------

    const rowHeaderMetric =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "82px",

        height:
            "28px",

        flexShrink:
            0,

        background:
            "linear-gradient(180deg, #45afe0 0%, #2695cc 100%)",

        color:
            "#ffffff",

        fontSize:
            "16px",

        fontWeight:
            700,

        boxShadow:
            `
            inset 0 1px 0 rgba(255,255,255,0.24),
            0 2px 5px rgba(38,149,204,0.18)
            `
    };


    //========================================================
    // Charts
    //========================================================

    const chartsContainer =
    {
        display:
            "flex",

        width:
            "100%",

        flex:
            1,

        minHeight:
            0,

        alignItems:
            "center",

        justifyContent:
            "space-around",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // Individual Chart
    //--------------------------------------------------------

    const chartContainer =
    {
        display:
            "flex",

        width:
            "50%",

        height:
            "100%",

        minHeight:
            "135px",

        alignItems:
            "center",

        justifyContent:
            "center",

        padding:
            "6px",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // Vertical Divider
    //--------------------------------------------------------

    const chartDivider =
    {
        width:
            "1px",

        height:
            "calc(100% - 24px)",

        minHeight:
            "110px",

        background:
            "rgba(25,29,33,0.07)",

        flexShrink:
            0
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={thisContainer}
            ref={thisId}
        >

            {/* ==========================================
                ROWS
            ========================================== */}

            <div style={rowsContainer}>


                {/* ======================================
                    DESKS
                ======================================= */}

                <div style={utilisationRow}>


                    {/* ----------------------------------
                        HEADER
                    ----------------------------------- */}

                    <div style={rowHeader}>

                        <div style={rowHeaderTitle}>

                            Desks

                        </div>


                        <div style={rowHeaderMetricHolder}>

                            <div style={rowHeaderMetricLabel}>

                                Total

                            </div>

                            <div style={rowHeaderMetric}>

                                {
                                    functions.formatNumber(
                                        deskCount,
                                        0
                                    )
                                }

                            </div>

                        </div>

                    </div>


                    {/* ----------------------------------
                        CHARTS
                    ----------------------------------- */}

                    <div style={chartsContainer}>


                        {/* Peak */}

                        <div style={chartContainer}>

                            <AmChartRingIndicator
                                percentage={percentage2}
                                width={120}
                                height={120}
                                icon="chair"
                                color="#D88A24"
                                label="Peak"
                                id="utilisationdeskspeak"
                            />

                        </div>


                        <div style={chartDivider} />


                        {/* Average */}

                        <div style={chartContainer}>

                            <AmChartRingIndicator
                                percentage={percentage4}
                                width={120}
                                height={120}
                                icon="chair"
                                color="#bb3300"
                                label="Avg"
                                id="utilisationdesksaverage"
                            />

                        </div>

                    </div>

                </div>


                {/* ======================================
                    MEETING ROOMS
                ======================================= */}

                <div style={utilisationRow}>


                    {/* ----------------------------------
                        HEADER
                    ----------------------------------- */}

                    <div style={rowHeader}>

                        <div style={rowHeaderTitle}>

                            Meeting Rooms

                        </div>


                        <div style={rowHeaderMetricHolder}>

                            <div style={rowHeaderMetricLabel}>

                                Total

                            </div>

                            <div style={rowHeaderMetric}>

                                {
                                    functions.formatNumber(
                                        meetingRoomCount,
                                        0
                                    )
                                }

                            </div>

                        </div>

                    </div>


                    {/* ----------------------------------
                        CHARTS
                    ----------------------------------- */}

                    <div style={chartsContainer}>


                        {/* Peak */}

                        <div style={chartContainer}>

                            <AmChartRingIndicator
                                percentage={percentage1}
                                width={120}
                                height={120}
                                icon="chair"
                                color="purple"
                                label="Peak"
                                id="utilisationroomspeak"
                            />

                        </div>


                        <div style={chartDivider} />


                        {/* Average */}

                        <div style={chartContainer}>

                            <AmChartRingIndicator
                                percentage={percentage3}
                                width={120}
                                height={120}
                                icon="chair"
                                color="crimson"
                                label="Avg"
                                id="utilisationroomsaverage"
                            />

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}
